module.exports = __webpack_public_path__ + "efd4eb4eedeab96c489f15e8b8b4f7ab.jpg";